import React from 'react'
import { Empty } from 'antd'

export default function NoData() {
  return (
    <Empty className='mt-20 flex-grow' description="Sembra non ci siano dati per il momento"/>
  )
}